import React, { useState } from 'react';

// импорт картинок
import bgImage from '../images/DSC_7309copy.JPG';
import klassikaImg from '../images/Классика_картинка.jpg';
import brusnikaImg from '../images/Брусника_картинка.jpg';
import smorodinaImg from '../images/Смородина_картинка.jpg';
import malinaImg from '../images/malina_compressed.png';
import assortiImg from '../images/DSC_7376.png';
import tap_icon from '../images/tap_icon.png';
import { useNavigate } from 'react-router-dom';
import '../style/About.css';

const items = [
  { src: klassikaImg, title: 'Наполеон Классический', desc: 'Воздушный торт…', weight: '1,2 кг', price: '2400 ₽', link: '/cake/classic' },
  { src: brusnikaImg, title: 'Наполеон с брусникой', desc: 'Волшебная ягода…', weight: '1,4 кг', price: '2500 ₽', link: '/cake/lingon' },
  { src: smorodinaImg, title: 'Наполеон со смородиной', desc: 'Мякоть плодов…', weight: '1,4 кг', price: '2500 ₽', link: '/cake/currant' },
  { src: malinaImg, title: 'Наполеон с малиной', desc: 'Ягодный конфи…', weight: '1,4 кг', price: '2500 ₽', link: '/cake/raspberry' },
  // { src: klukvaImg, title: 'Наполеон с клюквой', desc: 'Осенняя кислинка…', weight: '1,4 кг', price: '2300 ₽', link: '/cake/cranberry' },
  { src: assortiImg, title: 'Наполеон ассорти', desc: 'Набор вкусов…', weight: '1,4 кг', price: '2500 ₽', link: '/cake/mix' },
];


const About = () => {
  const navigate = useNavigate();
  const firstShelf = items.slice(0, 3);
  const secondShelf = items.slice(3, 6);
  const [showTip, setShowTip] = useState(false);

  return (
    <section className="About" id="About">
      {/* опционально фон */}
      <img className="img_about" src={bgImage} alt="Фон раздела Наши торты" />

      <h1>Наши торты</h1>
      <div
        className="about-info-icon"
        onClick={() => setShowTip(prev => !prev)}
        title="Подсказка"
      >
        <img className='tap_icon' src={tap_icon} width={25} height={25} alt='tap'></img>
      </div>

      {/* сам текст подсказки */}
      {showTip && (
        <div className="about-tip">
          Нажмите на фотокарточку, чтобы перейти на страницу продукта
        </div>
      )}

      {[firstShelf, secondShelf].map((shelfItems, shelfIdx) => (
        <div key={shelfIdx} className="shelf">
          {shelfItems.map((item, idx) => (
            <div key={idx} className="AboutPart">
              <img src={item.src} alt={item.title} onClick={() => navigate(item.link)}
                style={{ cursor: 'pointer' }} />
              <div className="layer">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <p>{`*Вес: ${item.weight} • Цена: ${item.price}`}</p>
              </div>
            </div>
          ))}
          <div className="shelf-bracket shelf-bracket-left" />
          <div className="shelf-bracket shelf-bracket-right" />
        </div>
      ))}
    </section>
  );
};

export default About;
